__turbopack_context__.v({
  "className": "XpZxSa_className",
  "variable": "XpZxSa_variable",
});
